// extracted by mini-css-extract-plugin
module.exports = {"toast-message_allignment":"non-cat-equipment-toast_toast-message_allignment__V6_gu"};